/* eslint-disable complexity */
import { Termin } from '@/domain/termine/shared/types/Termin';
import { TerminWiederholung } from '@/domain/termine/shared/types/TerminWiederholung';
import { isDateInZeitraum } from '@/domain/termine/shared/utils/dateValidations';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrBefore);

const wiederholungMap: Record<TerminWiederholung, dayjs.ManipulateType | null> =
  {
    [TerminWiederholung.TAEGLICH]: 'day',
    [TerminWiederholung.WOECHENTLICH]: 'week',
    [TerminWiederholung.MONATLICH]: 'month',
    [TerminWiederholung.JAEHRLICH]: 'year',
    [TerminWiederholung.OHNE]: null,
  };

export function generateWiederholungen(
  termin: Termin,
  monthStart: dayjs.Dayjs,
  monthEnd: dayjs.Dayjs,
): Termin[] {
  const occurrences: Termin[] = [];
  const start = dayjs(termin.datum);
  const end = termin.wiederholungBis ? dayjs(termin.wiederholungBis) : monthEnd;
  const wiederholungen = wiederholungMap[termin.wiederholung];

  function addTerminIfInZeitraum(date: dayjs.Dayjs) {
    if (isDateInZeitraum(date, monthStart, monthEnd)) {
      const formattedDate = date.format('YYYY-MM-DD');

      const beginnTime = termin.beginn
        ? dayjs(termin.beginn).format('HH:mm:ss')
        : null;

      const endeTime =
        termin.beginn && termin.ende
          ? dayjs(termin.ende).format('HH:mm:ss')
          : null;

      occurrences.push({
        ...termin,
        datum: formattedDate,
        beginn: beginnTime ? `${formattedDate}T${beginnTime}` : undefined,
        ende: endeTime ? `${formattedDate}T${endeTime}` : undefined,
        repetitionId: `${termin.id}_${formattedDate}`,
      });
    }
  }

  if (wiederholungen) {
    let current = start.clone();
    while (current.isSameOrBefore(end, 'day')) {
      addTerminIfInZeitraum(current);
      current = current.add(1, wiederholungen);
    }
  } else {
    addTerminIfInZeitraum(start);
  }

  return occurrences;
}
